import { SUBSCRIPTION_STATUS, type SubscriptionStatus } from './const';

const STATUS_LABEL: Record<SubscriptionStatus, string> = {
  [SUBSCRIPTION_STATUS.active]: 'Active',
  [SUBSCRIPTION_STATUS.pastDue]: 'payment failed',
  [SUBSCRIPTION_STATUS.canceled]: 'cancelled',
  [SUBSCRIPTION_STATUS.incomplete]: 'incomplete',
  [SUBSCRIPTION_STATUS.incompleteExpired]: 'incomplete expired',
  [SUBSCRIPTION_STATUS.unpaid]: 'unpaid',
  [SUBSCRIPTION_STATUS.noSubscription]: 'no subscription',
};

export const getSubscriptionStatusLabel = (status: SubscriptionStatus): string =>
  STATUS_LABEL[status] || status;
